<p *ngIf="showLoading" id="wrapper">
  <ion-spinner></ion-spinner>
  <span class="loadingLabel">{{loadingLabel}}</span>&nbsp;
</p>
<p *ngIf="hasError">
  <span class="errorLabel" (click)="resetAndRetry()">{{errorLabel}}</span>
</p>